import React from 'react';
import Icon from '../icon';
import { showMessageBox } from '../../actions/modal';
import { isEmpty } from '../../data/validation';
import { getPhrase } from '../../data/phrases';

export default class CommentInput extends React.PureComponent {
	constructor() {
		super();
		this.showInput = this.showInput.bind(this);
	}

	async showInput() {
		if (this.props.readOnly) {
			return;
		}
		const res = await showMessageBox(getPhrase('comment'), {
			type: 'input',
			multiline: true,
			input: this.props.value,
			maxLength: this.props.maxLength || 1000,
			optional: true
		});
		if (res === null) {
			return;
		}
		if (this.props.onChange) {
			this.props.onChange(res);
		}
	}

	render() {
		return <Icon
			name={isEmpty(this.props.value) ? 'commentEmpty' : 'commentSet'}
			active={!this.props.readOnly}
			hint={this.props.value || this.props.hint}
			className="ps-input comment"
			onMouseDown={this.showInput}
		/>;
	}
}
